const CompanyDocumentsAdapter = (data) => {
  if (!data) {
    return [];
  }

  const newArr = [];

  const prepareData = (i) => ({
    ...i,
    'shopping_centers.title': i.company?.shopping_center?.title,
    'chains.title': i.company?.chain?.title,
    'company_document_categories.title': i.category?.title,
    'companies.title': i.company?.title,
  });

  if (Array.isArray(data)) {
    data.forEach((i) => {
      newArr.push(prepareData(i));
    });

    return newArr;
  }

  return prepareData(data);
};

export default CompanyDocumentsAdapter;
